import React from 'react'
import { IoCloudDoneOutline } from "react-icons/io5";
import { FiX, FiTrash2 } from "react-icons/fi";

const MwButton = (props) => {
    const {
            actionType,
            onClick,
            children,
            type,
            size,
            classNameCustom,
            inGroup = false,
            disabled = false,
            withIcon = true,
        } = props
        let classItem = `app-button inline-flex items-center justify-center gap-2 text-sm border whitespace-nowrap ${size ==='sm' ? ' min-h-7 px-3 text-xs rounded-lg' : 'min-h-9 px-5 rounded-[10px]' } ${disabled ? 'cursor-not-allowed opacity-55 shadow-none' : 'cursor-pointer'} ${classNameCustom || ''} `;
        switch(type) {
            case 'secondary':
                classItem += ` bg-white border-slate-200 text-slate-700 shadow-sm ${ disabled || 'hover:text-[var(--themColor)] hover:border-[var(--primaryBorder)] hover:bg-[var(--primarySoft)]'} ${inGroup && 'rounded-none rounded-s-lg '}`
                break;
            case 'secondary-reverse':
                classItem += ` bg-white border-slate-200 text-slate-700 shadow-sm ${ disabled || 'hover:text-[var(--themColor)] hover:border-[var(--primaryBorder)] hover:bg-[var(--primarySoft)]'} ${inGroup && 'rounded-none rounded-e-lg '}`
                break;
            case 'secondary-inline-end':
                classItem += ` bg-white border-slate-200 text-slate-700 shadow-sm ${ disabled || 'hover:text-[var(--themColor)] hover:border-[var(--primaryBorder)] hover:bg-[var(--primarySoft)]'} ${inGroup && 'rounded-none  '}`
                break;
            case 'saveBtn':
                classItem += `primary-btn ${inGroup && 'rounded-none rounded-e-lg '}`
                break; 
            case 'deleteBtn':
                classItem +=  `bg-[var(--dangerSoft)] border-red-100 text-red-600 shadow-sm ${disabled || 'hover:bg-red-600 hover:text-white hover:border-red-600'} ${inGroup && 'rounded-none rounded-e-lg '}`   
                break; 
            case 'deleteBtn-inline':
                classItem +=  `bg-[var(--dangerSoft)] border-red-100 text-red-600 shadow-sm ${disabled || 'hover:bg-red-600 hover:text-white hover:border-red-600'} ${inGroup ? ' rounded-none border-y border-slate-200' : ''}`   
                break; 
            case 'cancelBtn':
                classItem +=  `bg-slate-100 border-slate-200 text-slate-600 shadow-sm ${disabled || 'hover:bg-slate-700 hover:text-white hover:border-slate-700'} ${inGroup && 'border-0 border-s border-t border-b rounded-none rounded-s-lg '}`   
                break; 
            case 'bottomBtn':
                classItem +=  ` rounded-none ${disabled ? 'bg-gray-400 text-slate-200 border-gray-400' : 'bg-[var(--themColor)] border-[var(--themColor)] text-slate-100 hover:bg-[var(--darkColor)]'}`   
                break; 
            default :
                classItem += ' bg-[var(--themColor)] border-[var(--themColor)] text-white shadow-sm hover:bg-[var(--primaryHover)] hover:border-[var(--primaryHover)]'
        }
    return (
        <button
            type={actionType}
            onClick={onClick}
            // onMouseOver={()=>console.log('hover')}
            
            disabled = {disabled}
            className={classItem}>
            {type === 'saveBtn' && withIcon && <IoCloudDoneOutline size={18} />}
            {(type === 'deleteBtn' || type === 'deleteBtn-inline') && withIcon && <FiTrash2 size={16} />}
            {type === 'cancelBtn' && withIcon && <FiX size={16} />}
            {children}
        </button>
    )
}

export default MwButton
